// extracted by mini-css-extract-plugin
export default {"pageWrap":"U-z","fullWidth":"V-z","heading":"W-z","fullBleed":"X-z","hidden":"Y-z"};